<template>
  <div class="space-y-4">
    <div class="grid gap-4 md:grid-cols-3">
      <InputField
        :readonly="handoverView"
        name="insuranceData.referenceNumber"
        :label="t('referenceNumber')"
      />
      <InputField name="insuranceData.licencePlate" :label="t('licencePlate')" />
    </div>
  </div>
</template>

<script setup lang="ts">
import InputField from '@/components/InputField.vue';
import { useI18n } from 'vue-i18n';

defineProps<{
  handoverView?: boolean;
}>();

const { t } = useI18n();
</script>

<i18n lang="json">
{
  "en": {
    "referenceNumber": "Reference number",
    "licencePlate": "Licence plate"
  },
  "de": {
    "referenceNumber": "Vorgangsnummer",
    "licencePlate": "Kennzeichen"
  },
  "es": {
    "referenceNumber": "Número de expediente",
    "licencePlate": "Matrícula"
  }
}
</i18n>
